import { defineStore } from "pinia"

import axios from "@axios"

const baseUrl = '/activitylog/'

// RM-451: the Activity Feed reads GET /activitylog/view itself
// (client/src/pages/admin-activity-feed.vue); this store only tracks events.
export const useActivityLogStore = defineStore('activityLogStore', () => {
  async function trackEvent(eventType, details = {}) {
    try {
      await axios.post(`${baseUrl}track`, { eventType, details })
    } catch (error) {
      // Silent fail for tracking — don't disrupt user experience
      console.error('Activity tracking failed:', error.message)
    }
  }

  return {
    trackEvent,
  }
})
